import { resources } from './resources'
import i18n from './setup_translation'

export { resources }
export default i18n